import { clientEnv } from './buildTimeEnv';
import { initDspApiKey } from './runtimePublicEnv';

// Runtime globals
window.API_BASE_URL =
  clientEnv.REACT_APP_SPOTLIGHT_API_URL || 'https://www.chillfree.tv/api';
window.COMPANY_ID =
  clientEnv.REACT_APP_COMPANY_ID || '6419d68d33c59c85e30cdc62';
window.CONTENT_BASE_URL =
  clientEnv.REACT_APP_CONTENT_BASE_URL || 'https://chillfreedspmedia.cachefly.net';
window.IMAGES_BASE_URL =
  clientEnv.REACT_APP_IMAGES_BASE_URL || 'https://chillfreedspmedia.cachefly.net/images';
window.EMBEDDED_JWT =
  (typeof window !== 'undefined' && window.__SPOTLIGHT_EMBEDDED_JWT__) ||
  process.env.REACT_APP_SPOTLIGHT_API_TOKEN;

if (process.env.NODE_ENV === 'development') {
  console.log('🔧 Development mode: API_BASE_URL set to:', window.API_BASE_URL);
  console.log('🔧 Development mode: COMPANY_ID set to:', window.COMPANY_ID);
  console.log('🔧 Development mode: CONTENT_BASE_URL set to:', window.CONTENT_BASE_URL);
  console.log('🔧 Development mode: IMAGES_BASE_URL set to:', window.IMAGES_BASE_URL);
  console.log(
    '🔧 Development mode: EMBEDDED_JWT set to:',
    window.EMBEDDED_JWT ? '[REDACTED]' : 'undefined',
  );
}

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import { tokenService } from './services/auth/TokenService';
import { enhancedOnRedirectCallback } from './utils/AuthUrlCleanup';

// Fetch DSP API key from config service before rendering
initDspApiKey().then(() => {
  // Initialize TokenService with embedded JWT
  tokenService.initializeWithEmbeddedJWT();

  const onRedirectCallback = enhancedOnRedirectCallback;

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <Auth0Provider
      domain={clientEnv.REACT_APP_AUTH0_DOMAIN}
      clientId={clientEnv.REACT_APP_AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: window.location.origin,
        scope: 'openid profile email',
      }}
      onRedirectCallback={onRedirectCallback}
      useRefreshTokens={true}
      cacheLocation="localstorage"
    >
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Auth0Provider>,
  );

  reportWebVitals();
});
